module.exports = __webpack_public_path__ + "img/grand-cancun-pool-2.10bc1432.jpg";